(function () {
  if (window.__BAPORSSA_ANALYTICS_EVENTS__) {
    return;
  }

  window.__BAPORSSA_ANALYTICS_EVENTS__ = true;

  var EVENT_NAMES = {
    CTA: "bap_cta_click",
    NAV: "bap_nav_click",
    PRODUCT_CARD: "bap_product_card_click",
    COLLECTION: "bap_collection_click",
    ARTICLE_PRODUCT: "bap_article_product_click",
    ADD_TO_CART: "bap_add_to_cart_click",
    BEGIN_CHECKOUT: "bap_begin_checkout_click",
    SEARCH: "bap_search_click",
    NEWSLETTER: "bap_newsletter_click"
  };

  var queue = [];
  var lastFormClick = typeof WeakMap === "function" ? new WeakMap() : null;
  var lastCartAttributionUpdate = "";
  var ATTRIBUTION_SESSION_KEY = "baporssa_attribution";
  var ATTRIBUTION_LOCAL_KEY = "baporssa_attribution_last";
  var LANDING_SESSION_KEY = "baporssa_landing_page_path";
  var ATTRIBUTION_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var ATTRIBUTION_PARAMS = {
    SOURCE: "bap_src",
    ARTICLE_PATH: "bap_article_path",
    ARTICLE_HANDLE: "bap_article",
    BLOG_HANDLE: "bap_blog",
    CLICK_ID: "bap_click_id",
    LANDING_PATH: "bap_landing"
  };
  var CONSENT_TEXT = /^(accept|accept all|allow all|agree|decline|reject|deny|manage preferences|privacy preferences|ok|got it|akzeptieren|alle akzeptieren|ablehnen|schließen|accepter|tout accepter|refuser|aceptar|rechazar|aceitar|recusar|prihvatiti|同意|接受|拒绝)$/i;
  var CONTROL_TEXT = /^(close|schließen|fermer|cerrar|chiudi|sluiten|weiter|next|previous|prev|back|zurück|vor|sebelumnya|berikutnya|menu|menü|go to .+|gehe zu element .+|page \d+|seite \d+|slide \d+|image \d+|bild vergrößern|link zum benutzerbild .+)$/i;
  var CONTROL_ATTRS = /(carousel|slideshow|slider|gallery|media|modal|dialog|drawer|popover|zoom|previous|next|close|thumbnail)/i;
  var SOCIAL_HOSTS = /(facebook\.com|instagram\.com|youtube\.com|youtu\.be|pinterest\.com|threads\.net|tiktok\.com|x\.com|twitter\.com)/i;
  var COMMERCIAL_PATHS = /\/(products|collections|cart|checkout|search)(\/|$)|\/policies\/(shipping|refund|return)-policy|\/pages\/(purchase-quiz|size|fit|shipping|returns|the-craft|brand-story|eyewear-encyclopedia)/i;
  var LOCALE_PREFIX = /^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i;
  var QUIZ_TEXT = /(quiz|style test|purchase quiz|fit quiz|go to quiz|take the quiz|take our quiz|sunglasses style|finden|test|測驗|测试|クイズ)/i;

  function clean(value, fallback, limit) {
    value = value == null ? fallback || "" : String(value);
    return value.replace(/\s+/g, " ").trim().slice(0, limit || 180);
  }

  function stripLocale(path) {
    return clean(path).replace(LOCALE_PREFIX, "") || "/";
  }

  function normalizePath(path) {
    path = clean(path);
    if (!path) return "";
    if (path.indexOf("shopify://") === 0) {
      path = path
        .replace(/^shopify:\/\/products\//, "/products/")
        .replace(/^shopify:\/\/collections\//, "/collections/")
        .replace(/^shopify:\/\/pages\//, "/pages/")
        .replace(/^shopify:\/\/blogs\//, "/blogs/");
    }
    if (path.charAt(0) !== "/" && !/^https?:\/\//i.test(path)) {
      path = "/" + path.replace(/^\/+/, "");
    }
    return path;
  }

  function pathFromUrl(url) {
    if (clean(url).indexOf("shopify://") === 0) {
      return normalizePath(url);
    }
    try {
      var parsed = new URL(url, window.location.origin);
      return normalizePath(parsed.pathname);
    } catch (error) {
      return normalizePath(url);
    }
  }

  function hostFromUrl(url) {
    try {
      return new URL(url, window.location.origin).hostname;
    } catch (error) {
      return "";
    }
  }

  function canonicalPath(path) {
    path = normalizePath(path);
    return stripLocale(path);
  }

  function handleFromPath(path, segment) {
    var parts = canonicalPath(path).split("/").filter(Boolean);
    var index = parts.indexOf(segment);
    return index >= 0 && parts[index + 1] ? parts[index + 1] : "";
  }

  function dataTargetFor(element) {
    return clean(
      element.getAttribute("data-url") ||
      element.getAttribute("data-href") ||
      element.getAttribute("data-link") ||
      element.getAttribute("data-target-url") ||
      element.getAttribute("data-target-path") ||
      element.getAttribute("data-destination") ||
      ""
    );
  }

  function hrefFor(element) {
    var direct = element.href || element.getAttribute("href") || dataTargetFor(element);
    if (direct) return direct;

    var linkedParent = element.closest("a[href]");
    if (linkedParent) return linkedParent.href || linkedParent.getAttribute("href") || "";

    var linkedChild = element.querySelector && element.querySelector("a[href]");
    if (linkedChild) return linkedChild.href || linkedChild.getAttribute("href") || "";

    var form = element.closest("form");
    if (form) return form.getAttribute("action") || "";

    return "";
  }

  function fallbackPathFor(element, eventName, href, path) {
    var text = textFor(element);

    if (!path && QUIZ_TEXT.test(text)) {
      return "/pages/purchase-quiz";
    }

    if (!path && eventName === EVENT_NAMES.SEARCH) {
      return "/search";
    }

    if (!path && eventName === EVENT_NAMES.ADD_TO_CART) {
      return "/cart/add";
    }

    return path || pathFromUrl(href);
  }

  function token(value, fallback) {
    value = clean(value, fallback || "unknown", 120).toLowerCase();
    value = value.replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    return value || fallback || "unknown";
  }

  function closestSection(element) {
    return element.closest("[id^='shopify-section-']");
  }

  function sectionId(element) {
    var section = closestSection(element);
    return section ? section.id.replace(/^shopify-section-/, "") : "";
  }

  function positionInSection(element) {
    var section = closestSection(element) || document;
    var selectors = "a[href],button,input[type='submit'],[role='button']";
    var items = Array.prototype.slice.call(section.querySelectorAll(selectors));
    return Math.max(0, items.indexOf(element) + 1);
  }

  function textFor(element) {
    var aria = element.getAttribute("aria-label");
    var title = element.getAttribute("title");
    var text = element.innerText || element.textContent || element.value || "";
    return clean(aria || title || text || element.getAttribute("name") || element.tagName.toLowerCase());
  }

  function attrForNoiseCheck(element) {
    return clean([
      element.getAttribute("aria-label"),
      element.getAttribute("aria-controls"),
      element.getAttribute("data-action"),
      element.getAttribute("data-testid"),
      element.getAttribute("class"),
      element.id
    ].filter(Boolean).join(" "), "", 500).toLowerCase();
  }

  function surfaceFor(element) {
    if (element.closest("header,.header,.navigation-drawer")) return "header";
    if (element.closest("footer,.footer")) return "footer";
    if (element.closest("product-card")) return "product_card";
    if (element.closest("article,.shopify-section--main-article")) return "article";
    if (element.closest("buy-buttons,product-form")) return "product_form";
    if (element.closest("[id^='shopify-section-template']")) return "main_content";
    return "body";
  }

  function destinationType(path, href) {
    path = canonicalPath(path);
    if (!href && !path) return "action";
    if (path.indexOf("/products/") !== -1) return "product";
    if (path.indexOf("/collections/") !== -1) return "collection";
    if (path.indexOf("/blogs/") !== -1) return "blog";
    if (path.indexOf("/pages/") !== -1) return "page";
    if (path === "/cart" || path.indexOf("/cart/") === 0) return "cart";
    if (path === "/checkout" || path.indexOf("/checkout/") === 0) return "checkout";
    if (path === "/search" || path.indexOf("/search") === 0) return "search";

    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return "external";
    } catch (error) {
      return "unknown";
    }

    return "internal";
  }

  function destinationHandle(path) {
    return (
      handleFromPath(path, "products") ||
      handleFromPath(path, "collections") ||
      handleFromPath(path, "blogs") ||
      handleFromPath(path, "pages") ||
      ""
    );
  }

  function clickType(eventName) {
    return eventName.replace(/^bap_/, "").replace(/_click$/, "");
  }

  function clickId(payload) {
    return [
      token(payload.page_type, "page"),
      token(payload.surface, "surface"),
      token(payload.section_id, "section"),
      token(payload.click_type, "click"),
      token(payload.target_path || payload.button_text, "target"),
      token(String(payload.position || 0), "0")
    ].join("__").slice(0, 180);
  }

  function blogHandleFromPath(path) {
    var parts = canonicalPath(path).split("/").filter(Boolean);
    return parts[0] === "blogs" && parts[1] ? parts[1] : "";
  }

  function articleHandleFromPath(path) {
    var parts = canonicalPath(path).split("/").filter(Boolean);
    return parts[0] === "blogs" && parts[2] ? parts[2] : "";
  }

  function storageGet(storage, key) {
    try {
      return storage ? storage.getItem(key) : "";
    } catch (error) {
      return "";
    }
  }

  function sessionStorageRef() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function localStorageRef() {
    try {
      return window.localStorage;
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      if (storage) storage.setItem(key, value);
    } catch (error) {
      // Storage may be blocked by privacy settings; click tracking should still publish.
    }
  }

  function storageRemove(storage, key) {
    try {
      if (storage) storage.removeItem(key);
    } catch (error) {
      // No-op.
    }
  }

  function readJsonStorage(storage, key) {
    var raw = storageGet(storage, key);
    if (!raw) return null;

    try {
      var parsed = JSON.parse(raw);
      if (parsed && parsed.expires_at && parsed.expires_at < Date.now()) {
        storageRemove(storage, key);
        return null;
      }
      return parsed;
    } catch (error) {
      storageRemove(storage, key);
      return null;
    }
  }

  function landingPagePath() {
    var current = canonicalPath(window.location.pathname);
    var sessionStore = sessionStorageRef();
    var stored = storageGet(sessionStore, LANDING_SESSION_KEY);
    if (stored) return stored;
    storageSet(sessionStore, LANDING_SESSION_KEY, current || "/");
    return current || "/";
  }

  function normalizeAttribution(attribution) {
    if (!attribution) return null;

    var sourcePath = canonicalPath(attribution.source_page_path || attribution.article_path || "");
    var landing = canonicalPath(attribution.landing_page_path || landingPagePath());

    return {
      source_type: clean(attribution.source_type || attribution.source || "article", "", 80),
      source_page_path: clean(sourcePath),
      source_page_url: clean(attribution.source_page_url || "", "", 500),
      source_page_title: clean(attribution.source_page_title || "", "", 220),
      source_blog_handle: clean(attribution.source_blog_handle || blogHandleFromPath(sourcePath), "", 120),
      source_article_handle: clean(attribution.source_article_handle || articleHandleFromPath(sourcePath), "", 160),
      first_click_id: clean(attribution.first_click_id || attribution.click_id || "", "", 180),
      last_click_id: clean(attribution.last_click_id || attribution.first_click_id || attribution.click_id || "", "", 180),
      destination_type: clean(attribution.destination_type || "", "", 80),
      destination_handle: clean(attribution.destination_handle || "", "", 160),
      target_path: clean(canonicalPath(attribution.target_path || ""), "", 220),
      landing_page_path: clean(landing),
      captured_at: clean(attribution.captured_at || new Date().toISOString(), "", 80),
      updated_at: new Date().toISOString(),
      expires_at: Date.now() + ATTRIBUTION_TTL_MS
    };
  }

  function persistAttribution(attribution) {
    var normalized = normalizeAttribution(attribution);
    if (!normalized || !normalized.source_page_path) return null;

    var serialized = JSON.stringify(normalized);
    storageSet(sessionStorageRef(), ATTRIBUTION_SESSION_KEY, serialized);
    storageSet(localStorageRef(), ATTRIBUTION_LOCAL_KEY, serialized);
    return normalized;
  }

  function getActiveAttribution() {
    var sessionStore = sessionStorageRef();
    var localStore = localStorageRef();
    var sessionAttribution = readJsonStorage(sessionStore, ATTRIBUTION_SESSION_KEY);
    if (sessionAttribution) return normalizeAttribution(sessionAttribution);

    var localAttribution = readJsonStorage(localStore, ATTRIBUTION_LOCAL_KEY);
    if (localAttribution) {
      storageSet(sessionStore, ATTRIBUTION_SESSION_KEY, JSON.stringify(localAttribution));
      return normalizeAttribution(localAttribution);
    }

    return null;
  }

  function attributionFromUrl() {
    try {
      var params = new URL(window.location.href).searchParams;
      var source = params.get(ATTRIBUTION_PARAMS.SOURCE);
      var articlePath = params.get(ATTRIBUTION_PARAMS.ARTICLE_PATH);
      var click = params.get(ATTRIBUTION_PARAMS.CLICK_ID);

      if (!source && !articlePath && !click) return null;

      return normalizeAttribution({
        source_type: source || "article",
        source_page_path: articlePath || "",
        source_blog_handle: params.get(ATTRIBUTION_PARAMS.BLOG_HANDLE) || "",
        source_article_handle: params.get(ATTRIBUTION_PARAMS.ARTICLE_HANDLE) || "",
        first_click_id: click || "",
        last_click_id: click || "",
        landing_page_path: params.get(ATTRIBUTION_PARAMS.LANDING_PATH) || landingPagePath(),
        captured_at: new Date().toISOString()
      });
    } catch (error) {
      return null;
    }
  }

  function buildArticleAttribution(payload) {
    var sourcePath = canonicalPath(window.location.pathname);
    var targetPath = canonicalPath(payload.target_path || "");

    if (sourcePath.indexOf("/blogs/") !== 0 || !articleHandleFromPath(sourcePath)) return null;
    if (targetPath.indexOf("/products/") !== 0 && targetPath.indexOf("/collections/") !== 0) return null;

    return normalizeAttribution({
      source_type: "article",
      source_page_path: sourcePath,
      source_page_url: window.location.href,
      source_page_title: document.title,
      source_blog_handle: blogHandleFromPath(sourcePath),
      source_article_handle: articleHandleFromPath(sourcePath),
      first_click_id: payload.click_id,
      last_click_id: payload.click_id,
      destination_type: payload.destination_type,
      destination_handle: payload.destination_handle,
      target_path: targetPath,
      landing_page_path: landingPagePath(),
      captured_at: new Date().toISOString()
    });
  }

  function addAttributionToPayload(payload, attribution) {
    var active = attribution || getActiveAttribution();
    payload.landing_page_path = clean(active && active.landing_page_path || landingPagePath());
    payload.attribution_source_type = clean(active && active.source_type || "");
    payload.attribution_article_path = clean(active && active.source_page_path || "");
    payload.attribution_blog_handle = clean(active && active.source_blog_handle || "");
    payload.attribution_article_handle = clean(active && active.source_article_handle || "");
    payload.attribution_click_id = clean(active && (active.last_click_id || active.first_click_id) || "");
    payload.attribution_first_click_id = clean(active && active.first_click_id || "");
    payload.attribution_captured_at = clean(active && active.captured_at || "");
    return payload;
  }

  function appendAttributionToLink(element, attribution) {
    var anchor = element && (element.matches("a[href]") ? element : element.closest("a[href]"));
    if (!anchor || !attribution) return;

    var rawHref = anchor.getAttribute("href") || "";
    if (!rawHref || rawHref.charAt(0) === "#" || /^(mailto|tel|javascript):/i.test(rawHref)) return;

    try {
      var url = new URL(rawHref, window.location.origin);
      if (url.origin !== window.location.origin) return;

      var targetPath = canonicalPath(url.pathname);
      if (targetPath.indexOf("/products/") !== 0 && targetPath.indexOf("/collections/") !== 0) return;

      url.searchParams.set(ATTRIBUTION_PARAMS.SOURCE, attribution.source_type || "article");
      url.searchParams.set(ATTRIBUTION_PARAMS.ARTICLE_PATH, attribution.source_page_path || "");
      url.searchParams.set(ATTRIBUTION_PARAMS.ARTICLE_HANDLE, attribution.source_article_handle || "");
      url.searchParams.set(ATTRIBUTION_PARAMS.BLOG_HANDLE, attribution.source_blog_handle || "");
      url.searchParams.set(ATTRIBUTION_PARAMS.CLICK_ID, attribution.last_click_id || attribution.first_click_id || "");
      url.searchParams.set(ATTRIBUTION_PARAMS.LANDING_PATH, attribution.landing_page_path || landingPagePath());
      anchor.setAttribute("href", url.pathname + url.search + url.hash);
    } catch (error) {
      // Navigation should never be blocked by attribution decoration.
    }
  }

  function inputForName(form, name) {
    var inputs = form.querySelectorAll("input[name]");
    for (var index = 0; index < inputs.length; index += 1) {
      if (inputs[index].getAttribute("name") === name) return inputs[index];
    }
    return null;
  }

  function setHiddenInput(form, name, value) {
    if (!form || !name || value == null || value === "") return;

    var input = inputForName(form, name);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.setAttribute("data-bap-attribution", "true");
      form.appendChild(input);
    }
    input.value = clean(value, "", 500);
  }

  function cartAttributionAttributes(attribution, payload) {
    if (!attribution) return null;

    return {
      _bap_source: attribution.source_type || "article",
      _bap_article_path: attribution.source_page_path || "",
      _bap_article_handle: attribution.source_article_handle || "",
      _bap_blog_handle: attribution.source_blog_handle || "",
      _bap_click_id: attribution.last_click_id || attribution.first_click_id || "",
      _bap_landing_page: attribution.landing_page_path || landingPagePath(),
      _bap_last_product_handle: payload && payload.product_handle || attribution.destination_handle || "",
      _bap_last_target_path: payload && payload.target_path || attribution.target_path || "",
      _bap_captured_at: attribution.captured_at || ""
    };
  }

  function updateCartAttribution(attribution, payload) {
    var attributes = cartAttributionAttributes(attribution, payload);
    if (!attributes || !window.fetch) return;

    var signature = JSON.stringify(attributes);
    if (signature === lastCartAttributionUpdate) return;
    lastCartAttributionUpdate = signature;

    var root = window.Shopify && Shopify.routes && Shopify.routes.root || "/";
    var url = root.replace(/\/?$/, "/") + "cart/update.js";

    fetch(url, {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {
      lastCartAttributionUpdate = "";
    });
  }

  function attachProductAttribution(form, attribution) {
    if (!form || !attribution) return;

    setHiddenInput(form, "properties[_bap_source]", attribution.source_type || "article");
    setHiddenInput(form, "properties[_bap_article_path]", attribution.source_page_path);
    setHiddenInput(form, "properties[_bap_article_handle]", attribution.source_article_handle);
    setHiddenInput(form, "properties[_bap_blog_handle]", attribution.source_blog_handle);
    setHiddenInput(form, "properties[_bap_click_id]", attribution.last_click_id || attribution.first_click_id);
    setHiddenInput(form, "properties[_bap_landing_page]", attribution.landing_page_path || landingPagePath());
    setHiddenInput(form, "properties[_bap_captured_at]", attribution.captured_at);
  }

  function attachCartAttribution(form, attribution) {
    var attributes = cartAttributionAttributes(attribution, null);
    if (!form || !attributes) return;

    Object.keys(attributes).forEach(function (key) {
      setHiddenInput(form, "attributes[" + key + "]", attributes[key]);
    });
  }

  function isCheckoutTrigger(element, form) {
    var name = clean(element.getAttribute("name") || "", "", 80).toLowerCase();
    var text = textFor(element).toLowerCase();
    var action = form && form.getAttribute("action") || "";

    if (name === "checkout") return true;
    if (/checkout|check out|proceed to checkout|secure checkout/.test(text)) return true;
    if (form && /\/cart(?:$|\?)/.test(action) && element.matches("button,input[type='submit'],[type='submit']")) return true;
    return false;
  }

  function classify(element, href, path) {
    var pageType = window.BAPORSSA_ANALYTICS_CONTEXT && window.BAPORSSA_ANALYTICS_CONTEXT.page_type || "";
    var articleScope = pageType === "article" || Boolean(element.closest("article,.shopify-section--main-article"));
    var text = textFor(element).toLowerCase();
    var form = element.closest("form");

    if (form && isCheckoutTrigger(element, form)) {
      return EVENT_NAMES.BEGIN_CHECKOUT;
    }

    if (
      element.matches("[type='submit']") &&
      (element.closest("buy-buttons,product-form") || (form && /\/cart\/add/.test(form.getAttribute("action") || "")))
    ) {
      return EVENT_NAMES.ADD_TO_CART;
    }

    if (href && (canonicalPath(path) === "/search" || href.indexOf("/search") !== -1 || element.getAttribute("aria-controls") === "search-drawer")) {
      return EVENT_NAMES.SEARCH;
    }

    if (form && /contact/.test(form.getAttribute("action") || "") && /email|newsletter|subscribe/i.test(form.innerText || "")) {
      return EVENT_NAMES.NEWSLETTER;
    }

    if (articleScope && (canonicalPath(path).indexOf("/products/") !== -1 || canonicalPath(path).indexOf("/collections/") !== -1)) {
      return EVENT_NAMES.ARTICLE_PRODUCT;
    }

    if (element.closest("header,footer,nav,.header,.footer,.navigation-drawer") || text === "menu") {
      return EVENT_NAMES.NAV;
    }

    if (element.closest("product-card") || canonicalPath(path).indexOf("/products/") !== -1) {
      return EVENT_NAMES.PRODUCT_CARD;
    }

    if (canonicalPath(path).indexOf("/collections/") !== -1) {
      return EVENT_NAMES.COLLECTION;
    }

    return EVENT_NAMES.CTA;
  }

  function isConsentClick(element, text) {
    if (!CONSENT_TEXT.test(text)) return false;
    return Boolean(element.closest(
      "[id*='cookie' i],[class*='cookie' i],[id*='privacy' i],[class*='privacy' i],[id*='consent' i],[class*='consent' i],.shopify-pc__banner,.shopify-pc__prefs"
    ));
  }

  function isUiControlClick(element, text, href, path) {
    if (href && path && COMMERCIAL_PATHS.test(canonicalPath(path))) return false;
    if (CONTROL_TEXT.test(text)) return true;

    var attrs = attrForNoiseCheck(element);
    if (CONTROL_ATTRS.test(attrs) && (!href || href === "#" || href.indexOf("javascript:") === 0)) return true;
    if (element.closest("[role='dialog'],dialog,.modal,.drawer,.popover") && (!href || !COMMERCIAL_PATHS.test(canonicalPath(path)))) return true;
    return false;
  }

  function isCommercialClick(element, eventName, href, path) {
    if (eventName === EVENT_NAMES.ADD_TO_CART || eventName === EVENT_NAMES.BEGIN_CHECKOUT || eventName === EVENT_NAMES.SEARCH || eventName === EVENT_NAMES.NEWSLETTER) {
      return true;
    }

    if (path && COMMERCIAL_PATHS.test(canonicalPath(path))) {
      return true;
    }

    if (eventName === EVENT_NAMES.ARTICLE_PRODUCT || eventName === EVENT_NAMES.PRODUCT_CARD || eventName === EVENT_NAMES.COLLECTION) {
      return true;
    }

    return false;
  }

  function shouldPublish(element, eventName, href, path) {
    var text = textFor(element).toLowerCase();
    var host = hostFromUrl(href);

    if (element.closest("[data-analytics-ignore='true']")) return false;
    if (isConsentClick(element, text)) return false;
    if (isUiControlClick(element, text, href, path)) return false;
    if (host && host !== window.location.hostname && SOCIAL_HOSTS.test(host)) return false;

    if (!href && !path && eventName !== EVENT_NAMES.ADD_TO_CART && eventName !== EVENT_NAMES.SEARCH && eventName !== EVENT_NAMES.NEWSLETTER) {
      return false;
    }

    return isCommercialClick(element, eventName, href, path);
  }

  function basePayload(element, eventName, href, path) {
    var context = window.BAPORSSA_ANALYTICS_CONTEXT || {};
    var surface = surfaceFor(element);
    var type = clickType(eventName);
    var normalizedPath = eventName === EVENT_NAMES.BEGIN_CHECKOUT ? "/checkout" : fallbackPathFor(element, eventName, href, path);
    var canonical = canonicalPath(normalizedPath);
    var destType = destinationType(canonical, href);
    var destHandle = destinationHandle(canonical);

    var payload = {
      event_id: "bap_" + Date.now() + "_" + Math.random().toString(36).slice(2, 10),
      event_name: eventName,
      page_type: clean(context.page_type || ""),
      page_template: clean(context.template || ""),
      page_path: clean(window.location.pathname),
      page_url: clean(window.location.href, "", 500),
      page_title: clean(document.title),
      page_referrer: clean(document.referrer, "", 500),
      section_id: clean(sectionId(element)),
      surface: clean(surface),
      click_type: clean(type),
      destination_type: clean(destType),
      destination_handle: clean(destHandle),
      button_text: textFor(element),
      target_url: clean(href, "", 500),
      target_path: clean(canonical),
      product_handle: clean(handleFromPath(canonical, "products")),
      collection_handle: clean(handleFromPath(canonical, "collections")),
      position: positionInSection(element),
      element_tag: clean(element.tagName.toLowerCase()),
      element_classes: clean(element.className || "")
    };

    addAttributionToPayload(payload);
    payload.click_id = clickId(payload);
    return payload;
  }

  function publish(eventName, payload) {
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== "function") {
      queue.push([eventName, payload]);
      return;
    }

    Shopify.analytics.publish(eventName, payload);
  }

  function flushQueue() {
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== "function") {
      return;
    }

    while (queue.length) {
      var item = queue.shift();
      Shopify.analytics.publish(item[0], item[1]);
    }
  }

  document.addEventListener("click", function (event) {
    var element = event.target.closest("a[href],button,input[type='submit'],[role='button']");

    if (!element || element.closest("[data-analytics-ignore='true']")) {
      return;
    }

    var href = hrefFor(element);
    var path = fallbackPathFor(element, "", href, href ? pathFromUrl(href) : "");
    var eventName = classify(element, href, path);
    path = fallbackPathFor(element, eventName, href, path);

    if (!shouldPublish(element, eventName, href, path)) {
      return;
    }

    var payload = basePayload(element, eventName, href, path);
    var form = element.closest("form");
    var attribution = null;

    if (eventName === EVENT_NAMES.ARTICLE_PRODUCT) {
      attribution = persistAttribution(buildArticleAttribution(payload));
      if (attribution) {
        addAttributionToPayload(payload, attribution);
        appendAttributionToLink(element, attribution);
      }
    }

    if (eventName === EVENT_NAMES.ADD_TO_CART || eventName === EVENT_NAMES.BEGIN_CHECKOUT) {
      attribution = getActiveAttribution();
      if (attribution && form) {
        if (eventName === EVENT_NAMES.ADD_TO_CART) {
          attachProductAttribution(form, attribution);
        } else {
          attachCartAttribution(form, attribution);
        }
      }
      if (attribution) updateCartAttribution(attribution, payload);
    }

    if (form && lastFormClick) {
      lastFormClick.set(form, {
        eventName: eventName,
        time: Date.now()
      });
    }

    publish(eventName, payload);
  }, true);

  document.addEventListener("submit", function (event) {
    var form = event.target;
    var action = form.getAttribute("action") || "";
    var eventName = "";

    if (/\/cart\/add/.test(action) || form.closest("product-form,buy-buttons")) {
      eventName = EVENT_NAMES.ADD_TO_CART;
    } else if (/\/cart(?:$|\?)/.test(action) && form.querySelector("[name='checkout'],button[type='submit'],input[type='submit']")) {
      eventName = EVENT_NAMES.BEGIN_CHECKOUT;
    } else if (/\/search/.test(action)) {
      eventName = EVENT_NAMES.SEARCH;
    } else if (/contact/.test(action) && /email|newsletter|subscribe/i.test(form.innerText || "")) {
      eventName = EVENT_NAMES.NEWSLETTER;
    }

    if (!eventName) {
      return;
    }

    var payload = basePayload(form, eventName, action, fallbackPathFor(form, eventName, action, pathFromUrl(action)));
    var attribution = getActiveAttribution();
    if (attribution && eventName === EVENT_NAMES.ADD_TO_CART) {
      attachProductAttribution(form, attribution);
      updateCartAttribution(attribution, payload);
    } else if (attribution && eventName === EVENT_NAMES.BEGIN_CHECKOUT) {
      attachCartAttribution(form, attribution);
      updateCartAttribution(attribution, payload);
    }

    if (lastFormClick) {
      var recent = lastFormClick.get(form);

      if (recent && recent.eventName === eventName && Date.now() - recent.time < 1500) {
        return;
      }
    }

    publish(eventName, payload);
  }, true);

  persistAttribution(attributionFromUrl());
  landingPagePath();
  window.setInterval(flushQueue, 1000);
})();
